import Vue from "vue";
import { Guid } from 'js-guid';

Vue.component("wto-notification-file-upload-table", {
	props: ["attachmenttype",
		"language",
		"vmdata",
		"tableref",
		"isreadonly",
		"iswithdialects",
		"attachmentLabel",
		"uploadLabel",
		"languageLabel",
		"uploadingText",
		"fileAttachmentLabel"
	],
	data() {
		return {
			fileData: [],
			filteredData: [],
			tableWithDialects: true,
			fileUploadTableDialects: [],
			files: [],
			forUploading: false,
			hasData: false,
			isRemoveAttachment: false,
			uploadRef: this.tableref + "Upload",
			inputId: Guid.newGuid().toString()
		};
	},
	methods: {
		getDialects: function () {
			this.$services.dialects.getForDropdown({
				language: this.language,
				isMainLanguagesOnTop: true
			})
				.then((data) => {
					this.fileUploadTableDialects = data.items;
				});
		},
		removeAttachment: function (file) {
			this.filteredData = this.filteredData.filter(item => item.guid != file.guid);
			this.$emit("update:vmdata", this.filteredData);
		},
		downloadFile: function (id, guid, name) {
			let downloadUrl = `../../../attachment/download?id=${id}&guid=${guid}&fileName=${name}`;
			const url = window.location.href;	
			if(url.toLowerCase().includes("provisionalrecords")){
				downloadUrl = `../../attachment/download?id=${id}&guid=${guid}&fileName=${name}`;
			}
			window.open(downloadUrl);
		},
	},
	mounted: function () {
		if (this.iswithdialects) {
			this.getDialects();
		} else {
			this.tableWithDialects = false;
		}

		if (this.vmdata) {
			this.fileData = this.vmdata;
			this.hasData = true;
		}
		
	},
	watch: {
		fileData: function (val) {
			this.filteredData = val;
			this.$emit("update:vmdata", val);
		},
		files: function () {
			let vm = this;
			var files = vm.files;
			var inValidFiles = files.filter(item => item.file.type != 'application/pdf')

			if (inValidFiles.length > 0) {
				this.files = [];
				this.$buefy.dialog.alert({
					title: htmlEntity.decode(window.labels.invalidFileFormatDialogTitle),
					message: htmlEntity.decode(window.messages.invalidFileFormatDialogMessage),
					confirmText: htmlEntity.decode(window.labels.ok)
				})
			} else {
				if (files.length > 0) {
					let formData = new FormData();

					for (let i = 0; i < files.length; i++) {
						formData.append('files', files[i].file, files[i].name)
					}

					formData.append('attachmentType', vm.attachmenttype)
					formData.append('language', vm.language)

					this.forUploading = true;

					vm.$services.notificationAttachments.uploadFile(formData)
						.then((response) => {
							let result = response.data.items;
							if (result.length > 0) {
								if (vm.filteredData.length > 0) {
									vm.fileData = vm.filteredData.concat(result);
								} else {
									vm.fileData = result;
								}
							}

							this.files = [];
							vm.forUploading = false;
						});
				}
			}

		},
	},
	template: `
		<div class="columns">
			<div class="column">
				<b-field :label="fileAttachmentLabel">
					<b-table :striped="true"
							 :narrowed="true"
							 :hoverable="true"
							 :data="filteredData"
							 :show-detail-icon="false"
							 :ref="tableref"
							 detailed
							 detail-key="id">

						<b-table-column v-if="iswithdialects" field="language" :label="languageLabel" width="40%" v-slot="props">
							<b-select :disabled="isreadonly" v-model="props.row.dialectCode" expanded>
								<option v-for="option in fileUploadTableDialects"
										:value="option.value"
										:key="option.value">
									{{ option.text }}
								</option>
							</b-select>
						</b-table-column>

						<b-table-column field="attachments" :label="attachmentLabel | decodeHTMLEntity" width="50%" v-slot="props">
							{{ props.row.fileName }}
						</b-table-column>

						<b-table-column field="" label="" width="10%" v-slot="props">
							<a @click="downloadFile(props.row.id, props.row.guid, props.row.fileName)">
								<i class="fas fa-download has-text-primary"></i>
							</a>
							<a v-if="!isreadonly" @click="removeAttachment(props.row)">
								<i class="fas fa-trash-alt has-text-danger"></i>
							</a>
						</b-table-column>
					</b-table>
				</b-field>
		
				<div v-if="forUploading" class="columns">
					<div class="column">
						<b-progress type="is-success" size="is-medium" show-value>
							<span style="color: black">{{ uploadingText }}...</span>
						</b-progress>
					</div>
				</div>

				<b-field v-if="!isreadonly">
					<file-upload
                        :input-id="inputId"
						accept="application/pdf" 
						v-model="files" extensions="pdf" 
						:multiple="true" class="button is-danger"> {{ uploadLabel | decodeHTMLEntity }}
					</file-upload>
				</b-field>

			</div>
		</div>
	`
});